import React from "react";

const ProgrammeTermsConditions = (props) => {
  return (
    <>
      {props?.content?.edges?.length > 0 && (
        <div
          className="container page-content"
          style={{ marginBottom: "70px" }}
        >
          <h2 className="mb-4">
            {props.content.edges[0].node.acfPartials.pHeading}
          </h2>
          <div
            dangerouslySetInnerHTML={{
              __html: props.content.edges[0].node.acfPartials.pContent,
            }}
          />
        </div>
      )}
    </>
  );
};

export default ProgrammeTermsConditions;
